import { ButtonPrimeReact, PrimeReactModal } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MODAL_STYLES } from "constants/primereactStyles"
import { Trans, useTranslation } from "react-i18next"

export interface ModalConfirmacionCierreProps {
  isOpen: boolean
  close: () => void
}

export const ModalConfirmacionCierre = ({
  isOpen = false,
  close,
}: ModalConfirmacionCierreProps) => {
  const { t } = useTranslation()

  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-80 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      baseZIndex={30}
      ptContext={MODAL_STYLES}
      closable={false}
      footer={
        <div
          key='BotonesCierreExito'
          className='tw-flex tw-justify-end tw-items-center'
        >
          <ButtonPrimeReact
            className='tw-w-full tw-p-6 !tw-bg-primary tw-text-simple-10'
            type='submit'
            onClick={close}
          >
            {`${t("mayor.modal.continueButton")}`}
          </ButtonPrimeReact>
        </div>
      }
    >
      <div className='tw-flex tw-flex-col tw-items-center'>
        <div className='tw-bg-background tw-rounded-full tw-p-4 tw-mx-auto'>
          <div className='tw-bg-white tw-rounded-full tw-border tw-border-solid tw-border-[#F2F2F2] tw-p-2'>
            <FontAwesomeIcon
              icon={["fal", "check"]}
              className='tw-w-10 tw-h-10 tw-text-success'
            />
          </div>
        </div>
        <p className='tw-mt-4 tw-mb-3 tw-text-center'>
          <Trans
            i18nKey='mayor.modal.finantialClosingSuccess'
            components={[
              <span
                className='tw-text-lg tw-text-text'
                key='0'
              />,
            ]}
            finantialClosingSuccess
          />
        </p>
      </div>
    </PrimeReactModal>
  )
}
